// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[5].use[1]!./FilespaceListItemBase.tokens.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FilespaceListItemBase-module__HeaderContainer__NyGWd {
    display: flex;

    &:focus-visible {
        border-radius: var(--ds-border-radius-sm);
        outline-offset: calc(-1 * var(--ds-05x));
    }
}

.FilespaceListItemBase-module__Header__QuZ9A {
    position: relative;
    width: 100%;
    padding: var(--ds-sm);
    border-radius: var(--ds-border-radius-sm);

    &:hover {
        background-color: var(--ds-interaction-hover);
    }
    /* focus-within, so the Btn stays shown once Tab moves focus from the link onto it.
       Intended: a click focuses the expand arrow too, keeping the Btn shown until focus leaves.
       :has(:focus-visible) would avoid that, but mid-Tab nothing matches, the Btn hides and Tab skips it. */
    &:hover,
    &:focus-within {
        /* stylelint-disable-next-line selector-max-specificity -- needed to display the FS item Btn */
        .FilespaceListItemBase-module__Button__agyCZ {
            display: flex;
        }
    }
}
/* Stretches the link's hit area over the row; the actions sit above it, so no interactive element is nested */
.FilespaceListItemBase-module__HeaderLink__KELhK {
    flex: 1;
    min-width: 0;

    &::after {
        position: absolute;
        inset: 0;
        border-radius: var(--ds-border-radius-sm);
        content: '';
    }
}

.FilespaceListItemBase-module__Actions__f9RWC {
    position: relative;
}

.FilespaceListItemBase-module__HeaderSelected__QQaYY {
    background-color: var(--ds-interaction-select);
    /* stylelint-disable-next-line selector-max-specificity -- needed to display the FS item Btn */
    .FilespaceListItemBase-module__Button__agyCZ {
        display: flex;
    }
}
/* In order for the name to not increase container container width */
.FilespaceListItemBase-module__IconAndNameContainer__faR8j {
    overflow: hidden;
}

.FilespaceListItemBase-module__IconAndNameContainerDisabled__UBSlX {
    color: var(--ds-filespace-item-disabled-color);
}

.FilespaceListItemBase-module__CloudDriveIconWrapper__yBzuP {
    display: flex;
    align-items: center;
    color: var(--ds-color-grey-10);
}

.FilespaceListItemBase-module__StatusIconWrapper__voJaw {
    display: flex;
    align-items: center;
}

.FilespaceListItemBase-module__Button__agyCZ {
    display: none;
}

.FilespaceListItemBase-module__AccordionPanel__yJNmX {
    padding-right: 0;
    padding-left: 0;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"HeaderContainer": `FilespaceListItemBase-module__HeaderContainer__NyGWd`,
	"Header": `FilespaceListItemBase-module__Header__QuZ9A`,
	"Button": `FilespaceListItemBase-module__Button__agyCZ`,
	"HeaderLink": `FilespaceListItemBase-module__HeaderLink__KELhK`,
	"Actions": `FilespaceListItemBase-module__Actions__f9RWC`,
	"HeaderSelected": `FilespaceListItemBase-module__HeaderSelected__QQaYY`,
	"IconAndNameContainer": `FilespaceListItemBase-module__IconAndNameContainer__faR8j`,
	"IconAndNameContainerDisabled": `FilespaceListItemBase-module__IconAndNameContainerDisabled__UBSlX`,
	"CloudDriveIconWrapper": `FilespaceListItemBase-module__CloudDriveIconWrapper__yBzuP`,
	"StatusIconWrapper": `FilespaceListItemBase-module__StatusIconWrapper__voJaw`,
	"AccordionPanel": `FilespaceListItemBase-module__AccordionPanel__yJNmX`
};
export default ___CSS_LOADER_EXPORT___;
